{
  "login": {
    "title": "Welcome to Policy Vision",
    "subtitle": "Sign in with your work account",
    "signInButton": "Sign in with Microsoft",
    "signingIn": "Signing in...",
    "footer": "By signing in, you agree to our Terms of Service and Privacy Policy"
  },
  "logout": {
    "button": "Logout",
    "confirm": "Are you sure you want to logout?"
  },
  "errors": {
    "loginFailed": "Login failed. Please try again.",
    "unauthorized": "You are not authorized to access this resource."
  }
}
